import { defineStore } from 'pinia';
import type { BreadCrumbItemProps } from '../components/BreadCrumb';
import { ref } from 'vue';

type BreadcrumbState = {
  items: BreadCrumbItemProps[];
  hideBackButton: boolean;
};

export const useBreadcrumbStore = defineStore('breadcrumb', () => {
  const items = ref<BreadcrumbState['items']>([]);
  const hideBackButton = ref<BreadcrumbState['hideBackButton']>(false);

  const setItems = (newValue: BreadCrumbItemProps[]) => {
    items.value = [...newValue];
  };

  const setHideBackButton = (value: boolean) => {
    hideBackButton.value = value;
  };

  const reset = () => {
    items.value = [];
    hideBackButton.value = false;
  };

  return { items, hideBackButton, setItems, setHideBackButton, reset };
});
